import React from "react";
import styled from "styled-components";

export default styled.div`
    padding: 10px 0;
    width: 100%;
`;
